// extracted by mini-css-extract-plugin
export default {"content":"NewsBlock_content__rPI2f","img":"NewsBlock_img__nBMGw"};